"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "title", "toolTip", "tooltipAlignment", "stringProvider", "minimal", "variant", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { Box, Button, Icon, Tooltip } from '@autoguru/overdrive';
import { EAlignment } from '@autoguru/overdrive/dist/components/Positioner/alignment';
import { ContentCopyIcon } from '@autoguru/icons';
import { useClipboardCopy } from '../hooks/useClipboardCopy';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CopyToClipboard = t0 => {
  const $ = _c(27);
  let buttonProps;
  let className;
  let stringProvider;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      className,
      title: t1,
      toolTip: t2,
      tooltipAlignment: t3,
      stringProvider,
      minimal: t4,
      variant: t5,
      size: t6
    } = _t);
    buttonProps = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = buttonProps;
    $[2] = className;
    $[3] = stringProvider;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    buttonProps = $[1];
    className = $[2];
    stringProvider = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  const title = t1 === undefined ? "COPY" : t1;
  const toolTip = t2 === undefined ? "Copy to clipboard" : t2;
  const tooltipAlignment = t3 === undefined ? EAlignment.LEFT : t3;
  const minimal = t4 === undefined ? true : t4;
  const variant = t5 === undefined ? "secondary" : t5;
  const size = t6 === undefined ? "small" : t6;
  let t7;
  if ($[10] !== stringProvider) {
    t7 = {
      stringProvider
    };
    $[10] = stringProvider;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const [onCopyRequest, tip] = useClipboardCopy(t7);
  const t8 = tip || toolTip;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsx(Icon, {
      icon: ContentCopyIcon
    });
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== buttonProps || $[14] !== minimal || $[15] !== onCopyRequest || $[16] !== size || $[17] !== title || $[18] !== variant) {
    t10 = /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
      minimal: minimal,
      variant: variant,
      size: size
    }, buttonProps), {}, {
      onClick: onCopyRequest,
      children: [title, t9]
    }));
    $[13] = buttonProps;
    $[14] = minimal;
    $[15] = onCopyRequest;
    $[16] = size;
    $[17] = title;
    $[18] = variant;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== className || $[21] !== t10) {
    t11 = /*#__PURE__*/_jsx(Box, {
      className: className,
      children: t10
    });
    $[20] = className;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8 || $[25] !== tooltipAlignment) {
    t12 = /*#__PURE__*/_jsx(Tooltip, {
      closeAfter: 3000,
      alignment: tooltipAlignment,
      label: t8,
      children: t11
    });
    $[23] = t11;
    $[24] = t8;
    $[25] = tooltipAlignment;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};